import React, { useState } from 'react';

const AnnouncementsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const announcements = [
    {
      id: 1,
      category: 'admission',
      type: 'New Admission Notice',
      title: 'New Admission Notice 2025-26',
      description: 'Applications open for all engineering courses. Last date: 15th Dec 2024',
      date: 'Dec 1, 2024',
      icon: 'fas fa-bullhorn',
      color: 'crimson'
    },
    {
      id: 2,
      category: 'examination',
      type: 'Examination',
      title: 'Semester Examination Schedule',
      description: 'Winter semester exams to commence from 20th December 2024',
      date: 'Nov 28, 2024',
      icon: 'fas fa-file-alt',
      color: 'blue-500'
    },
    {
      id: 3,
      category: 'event',
      type: 'Event',
      title: 'Technical Fest 2024',
      description: 'Annual technical festival registration starts. Multiple events and competitions',
      date: 'Nov 25, 2024',
      icon: 'fas fa-calendar',
      color: 'green-500'
    },
    {
      id: 4,
      category: 'scholarship',
      type: 'Scholarship',
      title: 'Scholarship Applications',
      description: 'Merit-based scholarship forms available. Apply before 10th December',
      date: 'Nov 22, 2024',
      icon: 'fas fa-award',
      color: 'orange-500'
    },
    {
      id: 5,
      category: 'placement',
      type: 'Placement',
      title: 'Campus Placement Drive',
      description: 'Top companies visiting campus for final year placements. Register now',
      date: 'Nov 20, 2024',
      icon: 'fas fa-building',
      color: 'purple-500'
    },
    {
      id: 6,
      category: 'fee',
      type: 'Fee Notice',
      title: 'Fee Payment Reminder',
      description: 'Last date for semester fee payment is 5th December 2024',
      date: 'Nov 18, 2024',
      icon: 'fas fa-exclamation-triangle',
      color: 'red-500'
    },
    {
      id: 7,
      category: 'result',
      type: 'Result',
      title: 'Mid-Semester Results Declared',
      description: 'Check your mid-semester examination results on the student portal',
      date: 'Nov 15, 2024',
      icon: 'fas fa-graduation-cap',
      color: 'indigo-500'
    },
    {
      id: 8,
      category: 'workshop',
      type: 'Workshop',
      title: 'AI/ML Workshop Series',
      description: 'Five-day workshop on Artificial Intelligence and Machine Learning. Limited seats available',
      date: 'Nov 12, 2024',
      icon: 'fas fa-robot',
      color: 'teal-500'
    },
    {
      id: 9,
      category: 'holiday',
      type: 'Holiday',
      title: 'Diwali Vacation Notice',
      description: 'College will remain closed from 10th Nov to 16th Nov for Diwali celebrations',
      date: 'Nov 5, 2024',
      icon: 'fas fa-umbrella-beach',
      color: 'pink-500'
    },
    {
      id: 10,
      category: 'sports',
      type: 'Sports',
      title: 'Annual Sports Meet 2024',
      description: 'Registration open for various sports events. Last date: 20th November',
      date: 'Nov 1, 2024',
      icon: 'fas fa-trophy',
      color: 'yellow-600'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Announcements', icon: 'fas fa-th' },
    { id: 'admission', name: 'Admission', icon: 'fas fa-bullhorn' },
    { id: 'examination', name: 'Examination', icon: 'fas fa-file-alt' },
    { id: 'event', name: 'Events', icon: 'fas fa-calendar' },
    { id: 'scholarship', name: 'Scholarship', icon: 'fas fa-award' },
    { id: 'placement', name: 'Placement', icon: 'fas fa-building' },
    { id: 'fee', name: 'Fee Notice', icon: 'fas fa-exclamation-triangle' },
    { id: 'result', name: 'Results', icon: 'fas fa-graduation-cap' },
    { id: 'workshop', name: 'Workshops', icon: 'fas fa-robot' },
    { id: 'holiday', name: 'Holidays', icon: 'fas fa-umbrella-beach' },
    { id: 'sports', name: 'Sports', icon: 'fas fa-trophy' }
  ];

  const filteredAnnouncements = selectedCategory === 'all' 
    ? announcements 
    : announcements.filter(announcement => announcement.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-slate text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold mb-4">Announcements</h1>
          <p className="text-base sm:text-lg md:text-xl opacity-90 max-w-3xl">
            Stay updated with the latest news, events, and important notices from FiT Engineering College.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 sm:py-8 bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="flex flex-wrap gap-2 sm:gap-3 justify-center">
            {categories.map(category => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-4 py-2 rounded-full font-medium text-sm transition-all ${
                  selectedCategory === category.id
                    ? 'bg-crimson text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <i className={`${category.icon} mr-2`}></i>
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Announcements List */}
      <section className="py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid gap-4 sm:gap-6">
            {filteredAnnouncements.map(announcement => (
              <div 
                key={announcement.id}
                className={`bg-white rounded-lg p-6 border-l-4 shadow-sm hover:shadow-md transition-shadow border-${announcement.color}`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 bg-${announcement.color} bg-opacity-10 rounded-lg flex items-center justify-center flex-shrink-0`}>
                    <i className={`${announcement.icon} text-${announcement.color} text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold text-white bg-${announcement.color}`}>
                        {announcement.type}
                      </span>
                      <span className="text-sm text-gray-500">{announcement.date}</span>
                    </div>
                    <h3 className="text-xl font-bold text-slate mb-2">{announcement.title}</h3>
                    <p className="text-gray-600">{announcement.description}</p>
                    <div className="mt-4 flex flex-wrap gap-3">
                      <button className="text-crimson font-semibold text-sm hover:underline">
                        Read More <i className="fas fa-arrow-right ml-1"></i>
                      </button>
                      <button className="text-gray-600 font-medium text-sm hover:text-crimson">
                        <i className="fas fa-download mr-2"></i>Download Notice
                      </button>
                      <button className="text-gray-600 font-medium text-sm hover:text-crimson">
                        <i className="fas fa-share-alt mr-2"></i>Share
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredAnnouncements.length === 0 && (
            <div className="text-center py-12">
              <i className="fas fa-inbox text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No announcements found</h3>
              <p className="text-gray-500">There are no announcements in this category at the moment.</p>
            </div>
          )}
        </div>
      </section>

      {/* Subscribe Section */}
      <section className="py-12 sm:py-16 bg-surface">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-4">Stay Updated</h2>
          <p className="text-gray-600 mb-8">
            Subscribe to our newsletter to receive the latest announcements directly in your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:border-crimson"
            />
            <button
              type="submit"
              className="bg-crimson hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default AnnouncementsPage;